export const reviewChangesToolMessage = (toolMessage: any, results: any) => {
    let contextText = `<No changes found>`;
    let truncatedContextText = `<No changes found>`;
    if (results.formattedResults) {
        contextText = `Here is a diff of the changes you've made:\n${results.formattedResults}\n\n\nAnd here is a code review given on it. Pay attention to any recommendations here:\n\`\`\`\n${results.codeReview ?? "<No review given>"}\n\`\`\``;
        truncatedContextText = `Here is a diff of the changes you've made:\n<Truncated for brevity>`;
    }

    const content = [{
        type: 'text',
        text: contextText
    }];
    const truncatedContent = [{
        type: 'text',
        text: truncatedContextText
    }];

    return {...toolMessage, content: content, truncatedContent: truncatedContent};
};